export default __webpack_public_path__ + "static/media/megagon_logo_transparent.df932071.svg";